import React, { useEffect } from 'react'
import { Form } from 'antd';
import { useFormik } from 'formik';
import { useMutation } from 'react-query';
import { api } from '../../../../../api/api';
import { DurationObj, ObjDB } from '../../../../../types/apiTypes';
import FormStatus from '../../../../../components/form/FormStatus/FormStatus';
import { useFormStatus } from '../../../../../utils/hooks/useFormStatus';
import { DurationFormFields } from '../../../../../types/formFieldTypes';
import EditPlaceholder from '../../../../../components/common/EditPlaceholder/EditPlaceholder';
import { getAntField } from '../../../../../utils/form';
import { clearDurationErrors, durationValidate, initialDurationFields } from '../../formData/DurationFormData';
import DurationFormInputs from '../DurationFormInputs/DurationFormInputs';
import { queryKeysDuration } from '../../../../../static/data/queryKeys';
import { invalidateQueries } from '../../../../../utils/rest';

type DurationEditFormProps = {
    editItem: ObjDB<DurationObj> | null
    setOpenedForm: React.Dispatch<React.SetStateAction<boolean>>
    setEditItem: React.Dispatch<React.SetStateAction<ObjDB<DurationObj> | null>>
}

const DurationEditForm: React.FC<React.PropsWithChildren<DurationEditFormProps>> = React.memo((props) => {
    const {
        editItem, setOpenedForm, setEditItem
    } = props

    const formStatus = useFormStatus()

    const {
        errors, values, touched,
        handleChange,
        submitForm, setValues, setErrors,
    } = useFormik<DurationFormFields>({
        initialValues: initialDurationFields,
        onSubmit: (values: DurationFormFields) => {
            mutate(values)
        },
        validate: durationValidate
    })

    const antField = getAntField<DurationFormFields>(values, errors, touched)

    const {
        mutate
    } = useMutation(
        async (values: DurationFormFields) => {
            if (editItem) return await api.duration.edit(values, editItem)
        },
        {
            mutationKey: 'duration-edit',
            onSuccess() {
                invalidateQueries(queryKeysDuration[0])
                formStatus.setMessage('Данные успешно изменены')
                formStatus.setStatus('success')
                setTimeout(clearEditItem, 1000)
            },
            onError(err: Error) {
                console.error('ERROR', err)
                formStatus.setMessage(`Ошибка: ${err.message}`)
                formStatus.setStatus('error')
                setTimeout(clearEditItem, 5000)
            },
            onMutate() {
                formStatus.setMessage('Отправка данных')
                formStatus.setStatus('fetching')
            }
        }
    )

    const clearForm = () => {
        setValues(initialDurationFields)
        setErrors(clearDurationErrors)
    }

    const clearEditItem = () => {
        clearForm()
        setOpenedForm(false)
        setTimeout(() => {
            setEditItem(null)
            formStatus.reset()
        }, 300)
    }

    const resetChanges = () => {
        if (editItem) {
            const { id, ...values } = editItem
            setValues(values)
            setErrors(clearDurationErrors)
        }
    }

    useEffect(() => {
        if (editItem) return resetChanges()
        clearForm()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editItem])


    if (!editItem) return <EditPlaceholder/>

    return (
        <Form
            fields={[antField('name')]}
        >
            {
                editItem &&
                <p className="uif-ant-form-title">
                    ID редактируемого объекта: <span>{editItem.id}</span>
                </p>
            }
            <DurationFormInputs
                handleChange={handleChange}
                resetChanges={resetChanges}
                submitForm={submitForm}
            />
            <FormStatus formStatus={formStatus}/>
        </Form>
    )
})

export default DurationEditForm